import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"
import { Container } from "@bw/bits"

const Subpages = ({ tabs }) => {
  if (!tabs || tabs.length === 0) {
    return null
  }
  return (
    <Wrapper>
      <Container>
        <Tabs>
          {tabs.map((item, i) => (
            <Tab key={i} to={item.to} activeClassName="active">
              {item.title}
            </Tab>
          ))}
        </Tabs>
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  overflow-x: auto;

  &:after {
    content: "";
    z-index: -1;
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-bottom: 1.3px solid #f3f3f3;
  }
`

const Tabs = styled.nav`
  display: flex;
  flex-direction: row;
  font-size: 15px;
`

const Tab = styled(Link)`
  border-bottom: 2px solid transparent;
  display: block;
  white-space: nowrap;
  padding: 25px 20px 11px;
  text-decoration: none;
  color: var(--primary);

  &.active {
    font-weight: 700;
    background-color: #f7f7f7;
    border-color: var(--primary);
  }
`

Subpages.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
}

export { Subpages }
